import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'node-fetch';
import FormPage from './FormPage';
import { dispatchEvent } from 'helpers/analytics/AnalyticsEventDispatcher';

const defaultSourceUrl = 'https://www.johnlewis.com';

const getRequestConfig = (data, apikey) => {
  const maxUrlCharLength = 999;
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'apikey': apikey,
    },
    body: JSON.stringify({
      ...data,
      sourceType: 'RTB_JL_SIGNUP',
      sourceUrl: window.location.href
        ? window.location.href.substring(0, maxUrlCharLength)
        : defaultSourceUrl,
      entity: 'JL',
      consentEmail: 'Y',
    }),
  };
}

const getErrorMessage = errorCode =>
  errorCode === 400
    ? 'There are errors below, please correct them and try again'
    : "We're sorry, but something's not working right now, please try again later";

const dispatchAnalyticsError = (action, errorCode) => {
  if (!window.jlData) {
    window.jlData = {};
  }
  window.jlData.error = getErrorMessage(errorCode);
  dispatchEvent('dataStateChange', { action });
}


class SignupForm extends React.Component {
  constructor() {
    super();
    this.state = {
      submitFormErrorCode: false
    };

    this.submitFormFields = this.submitFormFields.bind(this);
    this.onSubmitFailed = this.onSubmitFailed.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  onSubmitFailed(errorCode) {
    dispatchAnalyticsError('rtb.bannerError', errorCode);
  }

  handleOnChange() {
    this.setState({submitFormErrorCode: false});
  }

  submitFormFields(fields) {
    const { onSuccess } = this.props;
    // /permissions is an endpoint within the Browse application
    // it proxies the request onto the permissions service

    return new Promise((resolve, reject) => {
      const handleSuccess = () => {
        onSuccess();
        return resolve();
      };

      const handleError = error => {
        const errorStatus = error && error.status;
        dispatchAnalyticsError('rtb.bannerError', errorStatus);
        this.setState({ submitFormErrorCode: errorStatus});
        return reject(error);
      };

      const signupContainer = document.querySelector('#footer-email-signup-banner');
      const uri = signupContainer.getAttribute('data-permissions-api');
      const apikey = signupContainer.getAttribute('data-permissions-api-key');

      return fetch(uri, getRequestConfig(fields, apikey))
        .then(
          response =>
            response.status === 201 ? handleSuccess() : handleError(response)
        )
        .catch(handleError);
    });
  }

  render() {
    const errorCode = this.state.submitFormErrorCode;
    return (<FormPage submitFormErrorCode={errorCode} handleOnChange={this.handleOnChange} onSubmitFailed={this.onSubmitFailed} onFormSubmit={this.submitFormFields} />);
  }
}

SignupForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default SignupForm;
